import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { navigationPropType } from "../../../../state/modules/navigation";
import { getBackgroundImageUrl } from "../../../../helpers/navigationBackgroundImageResolver";

import NavAnchor from "../../NavAnchor";
import styles from "./MarketingImage.css";

const cx = classnames.bind(styles);

const MarketingImage = ({ item, isGradientBackground }) => (
  <div
    className={cx(styles.container, {
      [styles.container__column]: item.largeScreenColumnSpan === 1
    })}
  >
    {itemList(item, isGradientBackground)}
  </div>
);

const truncatedLabel = (item, largeScreenColumnSpan) =>
  largeScreenColumnSpan === 3
    ? item.label.substring(0, 26)
    : item.label.substring(0, 36);

const itemList = ({ items, largeScreenColumnSpan }, isGradientBackground) =>
  items.map(item => {
    const labelClasses = {
      [styles[`label__${item.largeScreenStyleType}`]]: true
    };
    if (isGradientBackground) {
      labelClasses[
        styles[`label__span${items.length / largeScreenColumnSpan}`]
      ] = true;
    }

    return (
      <NavAnchor
        key={item.id}
        item={item}
        className={styles.item}
        data-testid="marketing-image"
      >
        <img
          alt={item.label}
          src={getBackgroundImageUrl(item.largeScreenImageUrl, 320)}
        />
        {item.largeScreenStyleType !== "noTitle" ? (
          <span className={cx(styles.label, labelClasses)}>
            {truncatedLabel(item, largeScreenColumnSpan)}
          </span>
        ) : null}
      </NavAnchor>
    );
  });

MarketingImage.propTypes = {
  item: navigationPropType.isRequired,
  isGradientBackground: PropTypes.bool
};

MarketingImage.defaultProps = {
  isGradientBackground: false
};

export default MarketingImage;



// WEBPACK FOOTER //
// ./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/MarketingImage.js